import "./AboutBlock.css";
import about from '../../../../assets/images/about.png'
import bg from '../../../../assets/images/aboutbg.png'

function AboutBlock({ }) {

    return (
        <div className={`about-block`} >
            <img alt="" className="about-block__img" src={about}></img>
            <img alt="" className="about-block__img_bg" src={bg}></img>
            <p className="about-block__text">
                Являясь региональным дилером на территории Нижегородской области мы представляем продукцию шведской компании Colorex Sweden AB, которая работает на рынке более 60 лет. С момента своего основания в 1955 году компания завоевала европейский рынок и зарекомендовала себя как производитель высококачественных лаков и красок для строительства и ремонта.
                <br></br><br></br>
                Все краски производятся с учетом их использования в климатических условиях Скандинавии и прекрасно подходят для климата Европы и России.
            </p>
        </div >
    );
}

export default AboutBlock;